export const DEFAULT_PAGE_SIZE_PARTIAL = 3;
export const DEFAULT_PAGE_SIZE = 30;

export const SEARCH_DEBOUNCE_TIME = 800;
